module.exports = __webpack_public_path__ + "img/50n.40d7b29b.svg";